export const environment = {
   production: true,
   cms: 'https://cms4.peraquam.polimi.it',
   geoserver: 'https://www.peraquam.polimi.it/geoserver',
};
